export default {
  name: "OverflowTooltipText",
  props: {
    text: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: [Number, String],
      default: 200
    },
    textClass: {
      type: String,
      default: ""
    },
    tooltipClass: {
      type: String,
      default: ""
    },
    tooltipStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    textStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    refreshKey: {
      type: [String, Number, Boolean],
      default: null
    }
  },
  data() {
    return {
      overflow: false
    };
  },
  mounted() {
    this.updateOverflow();
    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(this.updateOverflow);
      this.resizeObserver.observe(this.$refs.text);
    } else {
      window.addEventListener("resize", this.updateOverflow);
    }
  },
  updated() {
    this.updateOverflow();
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener("resize", this.updateOverflow);
  },
  watch: {
    // 激活态等外部样式可能只改变字重而不改变盒子尺寸，需要显式重测。
    refreshKey() {
      this.$nextTick(this.updateOverflow);
    }
  },
  methods: {
    // 以实际渲染宽度判断，避免短文本也错误展示 Tooltip。
    updateOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.text;
        const overflow = Boolean(el && el.scrollWidth > el.clientWidth);
        if (overflow !== this.overflow) {
          this.overflow = overflow;
        }
      });
    }
  },
  render(h) {
    return h("Tooltip", {
      class: ["overflow-tooltip-text", this.tooltipClass],
      props: {
        content: this.text,
        transfer: true,
        maxWidth: this.maxWidth,
        disabled: !this.overflow
      },
      style: {
        display: "block",
        width: "100%",
        minWidth: "0",
        maxWidth: "100%",
        ...this.tooltipStyle
      }
    }, [h("span", {
      ref: "text",
      class: this.textClass,
      style: {
        display: "block",
        width: "100%",
        minWidth: "0",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        ...this.textStyle
      }
    }, this.text || "—")]);
  }
};